module.exports = __webpack_public_path__ + "static/media/laptop-phone-v2.0fac20ea.png";